import {Component, OnInit} from '@angular/core';
import {UserService} from '../user.service';
import {LayoutService} from '../../layout/layout.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EmployeeAttachService } from 'app/core/services/employee-attach.service';
const TABLE ="51";

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user:any;

  constructor(
    private userService: UserService,
    private sanitizer : DomSanitizer,
    private employeeAttachService : EmployeeAttachService,
    private layoutService: LayoutService) {
  }

  ngOnInit() {
    // this.userService.getLoginInfo().subscribe(user => {
    //   this.user = user
    // })
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.user = currentUser;
    this.user.username = currentUser.userSystem.fullName;
    let eId = currentUser.userSystem.employeeId;
    this.user.picture = "assets/img/avatars/sunny.png";
    //this.getImageEmployee(eId)
    //this.user.picture = "assets/img/avatars/sunny.png";
  }

  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }

  getImageEmployee(id){
    if(id==null){
      this.user.picture = "assets/img/avatars/sunny.png";
    }
    else{
      this.employeeAttachService.getProfilePictureUser({masterTable: TABLE , table : id ,flgPicture: true,flgStatus:true}).subscribe((response) => {
            if(response) {
              let blob = new Blob([response] );
              if(response.size==0){
                this.user.picture = "assets/img/avatars/sunny.png";
              }
              else{ 
                this.user.picture = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
                  // window.URL.createObjectURL(response);
                  //saveAs(response,"imagen");
              }
          }else{
            this.user.picture = "assets/img/avatars/sunny.png";
          }
       });
      }
     }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts